import { Link } from "react-router-dom";
import { useMediaQuery } from "beautiful-react-hooks";
import AppHeader from "./AppHeader";
import { useAuthState } from "../Context/auth-context";
import { useEffect, useState } from "react";

export default function LandHeader() {
  const isSmall = useMediaQuery("(max-width: 768px)");
  const { isAuth } = useAuthState();

  return (
    <>
      {isSmall ? (
        <div className="header2025">
          <AppHeader />
          <div className=" animated slideInDown fixed ">
            <div className="container">
              <div className="row">
                <div className="col-xl-12 pl-0 pr-0">
                  <div className="navigation">
                    <nav className="navbar navbar-expand-lg navbar-light bg-light">
                      {isSmall ? (
                        <Link to={"/"}>
                          <img
                            className={"logo-mobile-css"}
                            src={
                              "https://static.sinatether.com/images/main-logo.svg"
                            }
                            alt={"سیناتتر"}
                          />
                        </Link>
                      ) : (
                        <Link to={"/"}>
                          <img
                            className={"logo-desk-css"}
                            src={"./images/main-logo.svg"}
                            alt={"سیناتتر"}
                          />
                        </Link>
                      )}
                      <button
                        className={"navbar-toggler"}
                        type="button"
                        data-toggle="collapse"
                        data-target="#navbarNavDropdown"
                        aria-controls="navbarNavDropdown"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                      >
                        <span className="navbar-toggler-icon" />
                      </button>
                      <div
                        className="collapse navbar-collapse"
                        id="navbarNavDropdown"
                      >
                        <ul className="navbar-nav"></ul>
                      </div>

                      <div className="signin-btn ">
                        {isAuth ? (
                          <Link to={"/"}>
                            <button className="btn btn-primary text-white mybold jsdhsjhgfg53729342 fkjegrebrerwrw">
                              پنل کاربری
                            </button>
                          </Link>
                        ) : (
                          <Link to={"/login"}>
                            <button className="btn btn-primary text-white mybold jsdhsjhgfg53729342 fkjegrebrerwrw">
                              ورود / ثبت نام{" "}
                            </button>
                          </Link>
                        )}
                      </div>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="header animated slideInDown fixed ">
          <div className="container">
            <div className="row">
              <div className="col-xl-12 pl-0 pr-0">
                <div className="navigation">
                  <nav className="navbar navbar-expand-lg navbar-light bg-light">
                    <Link to={"/"}>
                      <img
                        className={"logo-desk-css"}
                        src={"./images/main-logo.svg"}
                        alt={"سیناتتر"}
                      />
                    </Link>

                    <div
                      className="collapse navbar-collapse jfsjnrnn323424"
                      id="navbarNavDropdown"
                    >
                      <ul className="navbar-nav skjdsjf">
                        <li className="li-width text-center">
                          <a href={"/USDT"}>
                            <div className="jshfswewwrwr1313">معامله سریع</div>
                          </a>
                        </li>

                        <li className="li-width text-center">
                          <a href={"/about"} className="jshfswewwrwr1313">
                            <div className="jshfswewwrwr1313">درباره ما</div>
                          </a>
                        </li>

                        <li className="li-width text-center">
                          <a href={"/rules-and-regulations"}>
                            <div className="jshfswewwrwr1313">
                              قوانین مقررات
                            </div>
                          </a>
                        </li>

                        <li className="li-width text-center">
                          <a href={"/leverage-crypto-currencies-exchange"}>
                            <div className="jshfswewwrwr1313">
                              ارزهای اهرم دار
                            </div>
                          </a>
                        </li>

                        <li className="li-width text-center">
                          <a href={"/hamster-kombat-exchange"}>
                            <div className="jshfswewwrwr1313">همستر کامبت</div>
                          </a>
                        </li>

                        <li className="li-width text-center">
                          <a href={"/mag/"}>
                            <div className="jshfswewwrwr1313">مجله کریپتو</div>
                          </a>
                        </li>
                      </ul>
                    </div>

                    <div className="signin-btn ">
                      {isAuth ? (
                        <Link to={"/"}>
                          <button className="btn btn-primary text-white mybold jsdhsjhgfg53729342 fkjegrebrerwrw">
                            پنل کاربری
                          </button>
                        </Link>
                      ) : (
                        <Link to={"/login"}>
                          <button className="btn btn-primary text-white mybold jsdhsjhgfg53729342 fkjegrebrerwrw">
                            ورود / ثبت نام{" "}
                          </button>
                        </Link>
                      )}
                    </div>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
